<template>
  <div class="home-function-item-container" :style="{ backgroundImage: `url(${require('../imgs/home_item_bg_' + bgImage + '.svg')})` }">
    <div class="home-function-item-title">{{ $t(itemTitle) }}</div>
    <div class="home-function-item-info">
      <h1>{{ $t(itemInfo) }}</h1>
      <h1>{{ $t(itemInfo2) }}</h1>
    </div>
    <div class="feature-symbol">0{{ itemImg }}</div>
  </div>
</template>

<script>

export default {
  name: 'HomeFunctionItem',
  data () {
    return {
      isZH: (navigator.language || navigator.browserLanguage).toLowerCase().includes('zh-cn'),
      itemImage: ''
    }
  },
  created () {
    this.itemImage = this.isZH ? '' : 'en_'
  },
  components: {
  },
  props: ['itemTitle', 'itemInfo', 'itemInfo2', 'bgImage', 'itemImg']
}
</script>

<style lang="less" scoped>
  .home-function-item-container{
    position: relative;
    //background: #222222;
    margin-left: 1.25rem;
    margin-right: 1.25rem;
    width: 36.875rem;
    height: 35.6875rem;
    border-radius: 3.125rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
    .home-function-item-title{
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 600;
      font-size: 2.875rem;
      line-height: 150%;
      margin-top: 3.375rem;
      color: #FFFFFF;
    }
    .home-function-item-info{
      overflow: hidden;
      margin-top: 0.8125rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      h1{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 1.5rem;
        line-height: 151.2%;
        color: #BEBEBE;
      }
    }
    .feature-symbol{
      margin-top: auto;
      margin-bottom: 3rem;
      font-size: 9rem;
      line-height: 1;
      font-weight: 800;
      color: rgba(255, 255, 255, 0.18);
    }
  }
  @media only screen and (max-width: 500px) {
    .home-function-item-container {
      width: 307px;
      height: 297px;
      border-radius: 26px;
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 20px;
      .home-function-item-container-bg {
        filter: blur(92.82px);
      }
      .home-function-item-title {
        font-size: 23.92px;
        margin-top: 28px;
      }
      .home-function-item-info {
        margin-top: 7px;
        h1 {
          font-size: 12.48px;
        }
      }
      .feature-symbol {
        margin-top: auto;
        margin-bottom: 24px;
        font-size: 72px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/subcomponents/HomeFunctionItem.vue